module.exports = __webpack_public_path__ + "static/img/bg-fr.641712ef.png";